<!--
 * @Author: wangyan1
 * @Description: 小组与学员
 * @Date: 2022-04-21 15:20
 * @LastEditTime: 2024-09-18 20:35:11
 * @FilePath: /teacher-xkh-web/src/views/groupManage/students/index.vue
-->
<template>
  <div class="student-list">
    <a-table
      :scroll="{ x: getTableWidth()}"
      :loading="stuLoading"
      :columns="columnsStudents1"
      :data-source="studentList"
      :pagination="false"
      row-key="id"
    >
      <!-- 姓名 / 手机号 -->
      <span slot="studentName" slot-scope="text, record" class="student-name" @click="showStudentDetail(record)">
        <a-tooltip trigger="click">
          <template slot="title" v-if="record.sourceType === 2 && !record.coursePackageId">
            暂无学习数据
          </template>
          <a-tooltip>
            <template slot="title">
              {{ text }}
            </template>
            <div style="width: 110px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">{{ text }}</div>
          </a-tooltip>
          <p>{{ record.phoneNumber }}</p>
        </a-tooltip>
      </span>
      <!-- 年级 -->
      <span slot="gradeName" class="plan-name" slot-scope="text, record">
        {{ record.gradeName }}
      </span>
      <!-- 被打回 -->
      <span slot="reject1Title" class="title-dom">
        被打回
      </span>
      <div class="min-width-slot-title" slot="finishLessonsTitle">
        已完成讲次
        <template v-if="groupInfo.sourceType !== 2">
          <a-tooltip placement="left">
            <template #title>
              <span>完成学AI课，课本例练，双色笔记，日积月累，融会贯通这五关的人数</span>
            </template>
            <span><a-icon type="question-circle" /></span>
          </a-tooltip>
        </template>
      </div>
      <span
        slot="reject1"
        slot-scope="text,record"
        :class="['tip-dom', {'tip-detail': record.calledBackForRevisionLessonNum > 0}]"
      >
        <a-tooltip
          placement="bottom"
          :get-popup-container="getGenerateTip"
          trigger="click"
          @visibleChange="visibleChange(visible, record, 1)"
        >
          <template v-if="record.calledBackForRevisionLessonNum > 0" slot="title">
            <div class="correction-lessons">
              <tabs-detail :correction-list="correctionList" />
            </div>
          </template>
          {{ record.calledBackForRevisionLessonNum }} （{{ record.calledBackForRevisionFenNum }}）
        </a-tooltip>
      </span>
      <!-- 被打回待订正 -->
      <!-- <span slot="reject2Title" class="title-dom">
        被打回待订正
      </span> -->
      <span
        slot="reject2"
        slot-scope="text,record"
        :class="['tip-dom', {'tip-detail': record.calledBackForRevisionWaitLessonNum > 0}]"
      >
        <a-tooltip
          placement="bottom"
          :get-popup-container="getGenerateTip"
          trigger="click"
          @visibleChange="visibleChange(visible, record, 2)"
        >
          <template v-if="record.calledBackForRevisionWaitLessonNum > 0" slot="title">
            <div class="correction-lessons">
              <tabs-detail :correction-list="correctionList" />
            </div>
          </template>
          {{ record.calledBackForRevisionWaitLessonNum }} （{{ record.calledBackForRevisionWaitFenNum }}）
        </a-tooltip>
      </span>
      <!-- 评五星数 -->
      <span slot="goodCountTitle" class="title-dom">
        评五星数
      </span>
      <span
        slot="goodCount"
        slot-scope="text, record"
        :class="['tip-dom', {'tip-detail': record.appraisingLessonNum > 0}]"
      >
        <a-tooltip
          placement="bottom"
          :get-popup-container="getGenerateTip"
          trigger="click"
          @visibleChange="visibleChange(visible, record, 3)"
        >
          <template v-if="record.appraisingLessonNum > 0" slot="title">
            <div class="correction-lessons">
              <tabs-detail :correction-list="correctionList" />
            </div>
          </template>
          {{ record.appraisingLessonNum }} （{{ record.appraisingFenNum }}）
        </a-tooltip>
      </span>
      <!-- 已完成讲次 -->
      <span slot="finishLessons" slot-scope="text, record">
        <template v-if="record.lessonCount && record.lessonCount > 0">
          {{ record.completeLessonCount }} / {{ record.lessonCount }}
        </template>
        <template v-else>
          -/-
        </template>
      </span>
    </a-table>
    <!-- 查看学员详情 -->
    <student-detail
      ref="studentDetailMod"
      :visible.sync="detailShow"
      @onClose="onDetailClose"
      :record="stuRecord"
      :group-info="groupInfo"
    />
  </div>
</template>
<script>
// import corList from '../components/correction-list.vue'
import tabsDetail from '../components/tabsDetail.vue'
import studentDetail from '../students/detail.vue'
import mixins from '@/utils/mixins'
import groupStuLogger from '@/utils/logger/groupStudent.js'
// import TabsDetail from '../components/tabs-detail.vue'
// 组内学生列表
const columnsStudents = [
  {
    dataIndex: 'studentName',
    key: 'studentName',
    title: '姓名/手机号',
    scopedSlots: { customRender: 'studentName' },
    minWidth: 120,
    fixed: 'left',
    ellipsis: true
  },
  {
    title: '年级',
    scopedSlots: { customRender: 'gradeName' },
    width: 80,
    ellipsis: true
  },
  {
    title: '被打回',
    slots: { title: 'reject1Title' },
    scopedSlots: { customRender: 'reject1' },
    width: 90,
    ellipsis: true
  },
  {
    title: '被打回待订正',
    // slots: { title: 'reject2Title' },
    scopedSlots: { customRender: 'reject2' },
    width: 120,
    ellipsis: true
  },
  {
    title: '评五星数',
    slots: { title: 'goodCountTitle' },
    scopedSlots: { customRender: 'goodCount' },
    // width: 90,
    ellipsis: true
  },
  {
    slots: { title: 'finishLessonsTitle' },
    scopedSlots: { customRender: 'finishLessons' },
    ellipsis: true
  }
]
export default {
  mixins: [mixins],
  props: {
    // 课程ID
    xkhTeacherCourseId: {
      type: Number,
      default: -1
    },
    // 归属小组信息
    groupInfo: {
      type: Object,
      default: () => {}
    },
    // 课程来源, 1:ITV 2:精准学
    sourceType: {
      type: Number,
      default: 1
    }
  },
  components: {
    // corList
    studentDetail,
    tabsDetail
    // TabsDetail
  },
  watch: {
    xkhTeacherCourseId(val) {
      console.log('xkhTeacherCourseId', val)
      this.initColumns()
    }
  },
  data() {
    return {
      warnVisible: false,
      columnsStudents1: [],
      columnsStudents,
      stuLoading: false,
      studentList: [], // 组内学生列表
      stuPagination: {
        pageSize: 100,
        total: 0,
        current: 1
      },
      correctionList: [], // 被打回 被打回待订正 评优
      correctionDetail: [], // 课程环节
      detailShow: false, // 学员详情控制
      stuRecord: {} // 学员数据
      // groupRecord: {}
    }
  },
  methods: {
    initColumns() {
      console.log('this.sourceType', this.groupInfo)
      if (this.groupInfo && this.groupInfo.sourceType === 2) {
        this.columnsStudents1 = columnsStudents.filter(item => !['被打回', '被打回待订正', '评五星数'].includes(item.title))
        return false
      }
      this.columnsStudents1 = columnsStudents
    },
    getTableWidth() {
      // return this.groupInfo.sourceType === 2 ? 560 : 600
      return 650
    },
    getGradeName(gradeId) {
      const grade = (this.gradeList || []).find(item => item.id === gradeId)
      console.log('getGradeName', gradeId, grade, this.gradeList)
      return grade.name || ''
    },
    // 查看学生详情
    showStudentDetail(record) {
      if (record.sourceType === 2 && !record.coursePackageId) {
        return
      }
      groupStuLogger.clickStuLogger({
        groupId: this.groupInfo.id,
        courseId: record.classTypeId,
        studentUserId: record.userId
      })
      console.log('点击了学生', record, this.groupInfo)
      this.stuRecord = record
      this.$refs.studentDetailMod.getStudentLesssonList(record, this.groupInfo)
      this.detailShow = true
    },
    lessonMouseOver(detailData) {
      // this.correctionDetail = detailData
    },
    lessonMouseOut() {
      this.correctionDetail = []
    },
    /**
     * 浮层回显
     */
    visibleChange(isShow, data, tag) {
      console.log('浮层回显', isShow, data)
      this.getStudentCorrection(data, tag)
    },
    // 获取打回  待订正等信息
    getStudentCorrection(data, tag) {
      this.correctionList = []
      const { classTypeId, userId } = data
      this.$service.groupManage.getStudentCorrection({
        classTypeId,
        userId,
        groupStudentType: tag
      }).then(res => {
        console.log('获取打回  待订正等信息', res)
        this.correctionList = res
      }).catch(e => {
        console.log('getIntragroupStudent', e)
      })
    },
    getGenerateTip() {
      return document.querySelector('.tip-dom')
    },
    clearStudentList() {
      this.studentList = []
    },
    /**
     * 获取组内学生列表
     */
    getGroupStudentList({ xkhTeacherCourseId, keyWords }) {
      this.clearStudentList()
      this.$service.groupManage.getIntragroupStudent({
        xkhTeacherCourseId,
        keyWords,
        pageNum: this.stuPagination.current,
        pageSize: this.stuPagination.pageSize
      })
        .then(res => {
          this.stuLoading = false
          // this.groupInfo = record
          this.studentList = res
          // console.log()
        })
        .catch(() => {
          this.stuLoading = false
        })
    }
  }
}
</script>
<style lang="less" scoped>
@import '~@/static/css/base.less';

:deep(.ant-popover-inner-content) {
  padding: 6px 0;

  .action-btn {
    height: 32px;
    line-height: 32px;
    padding: 0 16px;
    cursor: pointer;
    &:hover {
      background: #F5F7F9;
    }

    a {
      display: block;
      color: #505873;

      &:hover {
        color: #505873;
      }
    }
  }
}

.student-list {
  width: 100%;
  height: 100%;

  .student-name {
    cursor: pointer;
    color: #3262FD;
  }
  :deep(.ant-tooltip-placement-rightTop) {
    .ant-tooltip-arrow{
      left: -2px;
    }
  }
  .tip-dom{
    font-size: 14px;
    &.tip-detail {
      cursor: pointer;
      color: #3262FD;
    }
    .icon-help {
      color: #505873;
    }
    :deep(.ant-tooltip-inner) {
      padding: 12px;
      /* width: 206px; */
    }

    .title{
      color: @gray-4;
      margin-bottom: 8px;
    }
    .list{
      color: @gray-10;
      display: flex;
      flex-wrap: wrap;
      padding: 0 8px 0 10px;

      span{
        padding: 2px 4px;
        height: 26px;
        background: @gray-2;
        border-radius: 3px;
        margin-right: 8px;
        margin-bottom: 8px;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        white-space: nowrap;
      }
    }
    .dot{
      height: 4px;
      width: 4px;
      display: inline-block;
      border-radius: 50%;
      background: @gray-4;
      vertical-align: middle;
      margin-right: 6px;
      position: relative;
      top: -2px;
    }
  }

  .table-wrapper {
    position: relative;
    flex: 0 1 auto;
    overflow: auto;

    .student-list-box {
      flex: 1;
      border-left: 1px solid #e0e0e0;
      overflow: hidden;
      padding-left: 10px;
    }
    .ant-table-wrapper {
      height: 100%;
      overflow: auto;

      :deep(tr) {
        line-height: 32px;
      }

      .plan-name {
        min-width: 120px;
      }

      .action {
        display: flex;
        a {
          margin-right: 16px;
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }

  }

  .pagination {
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    height: 72px;
    background-color: white;
    padding-right: 18px;
  }

  .correction-lessons {
    display: flex;
    flex-direction: row;
    width: 140px;
    max-height: 300px;
    .lessons-box {
      width: 50%;
      li {
        width: 100%;
        height: 28px;
        line-height: 28px;

        &:hover {
          color: #1890ff;
          cursor: pointer;
        }
        &.lesson-current {
          font-weight: 700;
          color: #1890ff;
        }
      }
    }
    .correction-box {
      border-left:  solid 1px #efefef;
      flex: 1;
      // height: 100%;
      li {
        text-align: center;
        height: 28px;
        line-height: 28px;
      }
    }
  }
}

.action-btns-wrap {
    display: flex;
    padding: 4px 0;
    .action-btns-item {
      &:hover {
        .iconfont {
          &::before {
            content: '\e6ce'
          }
        }
      }
    }
  }
.min-width-slot-title {
  min-width: 60px;
  word-break: keep-all;
}
</style>
